import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router } from '@angular/router';
import {Observable} from 'rxjs/Observable';
import 'rxjs/Rx';
import 'rxjs/observable/forkJoin';
import {BaseStepComponent } from '../base-step/base-step.component';
import {RefundReason} from '../../shared/models/refund-reason';
import {ReasonCode} from '../../shared/models/reason-code';
import {Currency} from '../../shared/models/currency';
import {WORKFLOW_DATA_SERVICE_TOKEN} from '../../shared/services/workflow-data.service';
import {TRAVEL_CREDIT_SERVICE_TOKEN} from '../../shared/services/travel-credit.service';
import {NavigationService} from '../../shared/services/navigation.service';
import {Credit} from '../../shared/models/credit';

@Component({
  selector: 'app-credit-step',
  templateUrl: './credit-step.component.html',
  styleUrls: ['./credit-step.component.css']
})
export class CreditStepComponent extends BaseStepComponent implements OnInit, OnDestroy {

  reasons: Array<RefundReason> = [];
  filteredReasons: Array<RefundReason> = [];
  reasonCodes: Array<ReasonCode> = [];
  currencies: Array<Currency> = [];
  feeAmountWaived: string;
  valueWaived: string;
  selectedCurrency = 0;
  selectedReason = 0;
  selectedReasonCode = 0;
  fareMasked: boolean;
  private subscription: any;

  constructor(route: ActivatedRoute, @Inject(WORKFLOW_DATA_SERVICE_TOKEN) private workflowDataService,
              @Inject(TRAVEL_CREDIT_SERVICE_TOKEN) private travelCreditService, navigationService: NavigationService,
              router: Router) {
    super(route, navigationService, router);
  }

  ngOnInit() {
    let self = this;
    Observable.forkJoin([this.travelCreditService.getReasonCodes(),
                         this.travelCreditService.getRefundReasons(),
                         this.travelCreditService.getCurrencies()]).subscribe(data => {
        self.reasonCodes.push(...data[0] as Array<ReasonCode>);
        self.reasons.push(...data[1] as Array<RefundReason>);
        self.currencies.push(...data[2] as Array<Currency>);
        self.loadCredit();
      },
    err => { },
    () => { });
  }

  loadCredit() {
    this.subscription =  this.workflowDataService.getCredit.subscribe(credit => {
      if (!credit) {
        return;
      }

      if (credit.reasonCode) {
        this.selectedReasonCode = credit.reasonCode.id;
        this.onSelectReasonCode(this.selectedReasonCode);
      }
      if (credit.refundReason) {
        this.selectedReason = credit.refundReason.id;
      }
      if (credit.currency) {
        this.selectedCurrency = credit.currency.id;
      }
      this.valueWaived = credit.valueWaived;
      this.feeAmountWaived = credit.feeAmountWaived;
      this.fareMasked = credit.fareMasked;
      this.travelCreditType = credit.travelCreditType;
    });
  }

  setCredit() {
    let reasonCode = this.reasonCodes.find(r => r.id === +this.selectedReasonCode);
    let reason = this.reasons.find(r => r.id === +this.selectedReason);
    let currency = this.currencies.find(c => c.id === +this.selectedCurrency);
    let credit = new Credit(reasonCode, reason, currency, this.fareMasked, this.feeAmountWaived, this.valueWaived, this.travelCreditType);
    this.workflowDataService.setCredit(credit);
  }

  onSelectReasonCode(reasonCodeId) {
    this.filteredReasons = this.reasons.filter((item) => item.reasonCodeId === +reasonCodeId);
    this.selectedReason = 0;
  }

  maskFareValue() {
    if (this.fareMasked)
      this.valueWaived = "0.00";
  }

  ngOnDestroy() {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/steps/credit-step/credit-step.component.ts